import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Auth0ContactForm from 'auth0-contact-form';
import { NavLink } from 'fluxible-router';
import { connectToStores } from 'fluxible-addons-react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.module.styl';
import Logo from './Logo';
import HamburgerMenu from './HamburgerMenu';
import NavLinks from './NavLinks';
import ActionArea from './ActionArea';
import SearchBox from '../SearchBox';
import NavigationStore from '../../stores/NavigationStore';
import { login, signup } from '../../action/navigateAuthentication';

class Header extends Component {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      showSearch: false,
      expandMenu: false
    };
  }

  componentDidMount() {
    this.createContactForm(window.metricsLib);
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleMenuToggle(force) {
    const expandMenu = typeof force !== 'undefined' ? force : !this.state.expandMenu;
    this.setState({ expandMenu });
  }

  handleScroll() {
    if ($(window).scrollTop() > this.headerEl.offsetHeight) {
      if (!this.state.showSearch) {
        this.setState({ showSearch: true });
      }
    } else if (this.state.showSearch) {
      this.setState({ showSearch: false });
    }
  }

  createContactForm(metricsLib) {
    this.contactForm = new Auth0ContactForm({
      onModalOpen() {
        metricsLib.track('open:talk-to-sales');
      },
      onFormSuccess(metricsData) {
        metricsLib.track('register:lead:talk-to-sales-modal', metricsData);
        metricsLib.track('sent:talk-to-sales', metricsData);
      },
      onFormFail(metricsData) {
        metricsLib.track('fail:register:lead:talk-to-sales-modal', metricsData);
        metricsLib.track('fail-sent:talk-to-sales', metricsData);
      }
    });
  }

  render() {
    const { currentRouteName, currentSection, sections, isAuthenticated, user } = this.props;
    const { expandMenu, showSearch } = this.state;

    return (
      <header
        ref={el => this.headerEl = el} 
        className={`
          ${styles.header} 
          ${showSearch || currentRouteName !== 'home' ? styles.showSearch : ''} 
          ${currentRouteName === 'home' ? styles.homeHeader : ''}
          ${expandMenu ? styles.expandedMenu : ''}
        `}
      >
        <div className={`container ${styles.headerContainer} ${styles.flexRow}`}>
          <div className="col-md-3">
            <h1 className={styles.brand}>
              <Logo />

              <OverlayTrigger
                placement="bottom"
                overlay={(<Tooltip id="tooltip-logo">Docs Home</Tooltip>)}
              >
                <NavLink href="/docs" className={styles.title} onClick={() => this.handleMenuToggle(false)}>
                  Docs
                </NavLink>
              </OverlayTrigger>

              <HamburgerMenu expandMenu={expandMenu} onClick={() => this.handleMenuToggle()} />
            </h1>
          </div>


          <nav className={styles.flexRow}>
            <div className={styles.flexNav}>
              <NavLinks
                sections={sections}
                currentSection={currentSection}
                onClick={() => this.handleMenuToggle(false)} 
              />

              <SearchBox placeholder={'Search'} className={styles.navbarSearch} />
            </div>

            <ActionArea
              isAuthenticated={isAuthenticated}
              user={user}
              login={() => this.context.executeAction(login(window.location.pathname))}
              signup={() => this.context.executeAction(signup)}
              talkToSales={() => this.contactForm.show()}
            />
          </nav>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  isAuthenticated: PropTypes.bool,
  user: PropTypes.object,
  currentRouteName: PropTypes.string.isRequired,
  currentSection: PropTypes.string.isRequired,
  sections: PropTypes.array.isRequired
};

export default connectToStores(Header, [NavigationStore], context => ({
  sections: context.getStore(NavigationStore).getSections()
}));
